import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const meGetNewsCategories = createQueryFn(
  QueryNameSpace.meGetNewsCategories,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const { subscriptions } = await DigiobcanApi.meGetNewsCategories(params);
    return subscriptions;
  },
);
